import {useEffect, useState} from 'react';

const CallToCrm = ({showCrm, setShowCrm}) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setInnerHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {!showCrm && (
        <>
          {innerHeight > 520 && (
            <div
              onClick={() => setShowCrm(true)}
              style={{
                position: 'absolute',
                bottom: '16px',
                left: '17px',
                fontWeight: '400',
                fontSize: '14px',
                color: '#707070',
                textAlign: 'left',
              }}>
              تماس با پشتیبانی
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CallToCrm;
